import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { UiModule } from '@app/ui';
import { PropertyUpdateStatusByPlatform } from '@app/shared/interfaces/lib/property.interface';
@Component({
  standalone: true,
  selector: 'sbnb-property-update-status',
  templateUrl: './property-update-status.component.html',
  imports: [CommonModule, UiModule],
})
export class PropertyUpdateStatusComponent implements OnInit {
  @Input() edited: boolean;
  @Input() moveIcons = false;
  @Input() hasAirbnbListing = true;
  @Input() hasBookingListing = false;
  @Input() hasDirectSites = true;

  public status = PropertyUpdateStatusByPlatform;

  constructor() {}

  ngOnInit(): void {}
}
